module.exports = __webpack_public_path__ + "static/media/VU5640F0.bf03746e.png";